module.exports = __webpack_public_path__ + "img/m-1.1c6ebac1.png";